import Image from "next/image";
import { FooterStoreLinkItem } from "./footerItems";
import { FooterStoreButtons } from "./FooterStoreButtons";
import { Typography } from "@/components/Typography";

type FooterGetAppSectionProps = {
  items: FooterStoreLinkItem[];
};

export const FooterGetAppSection = ({ items }: FooterGetAppSectionProps) => {
  return (
    <div className="flex flex-col gap-2 pt-4 text-left md:border-0 md:pt-0">
      <Typography variant="subtitle2">Get the app | ទាញយកកម្មវិធី</Typography>

      <div className="flex flex-cols gap-4">
        <div className="flex w-[108px] items-center justify-center rounded-2xl border bg-white p-2">
          <Image
            src="/store/tovtrip-qr.jpg"
            alt="Tovtrip app QR code"
            width={109}
            height={109}
          />
        </div>
        <div className="flex-1 md:flex-none">
          <FooterStoreButtons items={items} />
        </div>
      </div>
    </div>
  );
};
